























































































import { Component, Vue } from 'vue-property-decorator';
import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import { NotificationModel } from '@/models/notification';
import commonServices from '@/services/common-services';

@Component({})
export default class Notification extends Vue {
    private eventEmit = {
        totalNotification: 'totalNotification'
    };

    private timer: any;

    private pageSettings = {
        rowPerPage: 10,
        pageSize: 3,
        pageIndex: 1,
        total: 0,
    };
    private listNotification: NotificationModel[] = [];
    private isLoading = false;

    get unreadCount() {
        return (this.listNotification || []).filter(x => x.status === 0).length;
    }

    private async created() {
        this.timer = setInterval(() => {
            this.loadNotification();
        }, APP_CONFIG.notifyRefreshTime * 1000);

        eventBus.$on(APP_CONFIG.eventBusAction.reloadNotification, () => {
            this.loadNotification();
        });

        this.loadNotification();
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    private async loadNotification() {
        this.listNotification = [];
        this.isLoading = true;
        const filter = [{ column: 'Status', value: [0,2], condition: 'in' }];
        const result = await commonServices.getNotification(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filter, true);
        if (result && result.status === 200 && result.data.status === 200) {
            for (const item of result.data.data) {
                const notification = new NotificationModel();
                notification.createdDate = item.CreatedDate;
                notification.id = item.ID;
                notification.isBuy = item.IsBuy;
                notification.mainOrder = item.MainOrder;
                notification.message = item.Message;
                notification.orderId = item.OrderID;
                notification.orderType = item.OrderType;
                notification.receivedId = item.ReceivedID;
                notification.status = item.Status;

                this.listNotification.push(notification);
            }
            if(this.listNotification.length === 0) {
                this.$emit(this.eventEmit.totalNotification, 0);
            } else {
                this.$emit(this.eventEmit.totalNotification, this.listNotification.filter(x => x.status === 0).length);
            }
        }
        this.isLoading = false;
    }

    private async onReadNotification(notif: NotificationModel) {
        try {
            commonServices.updateStatusNotification(notif.id, { Status: 1 }).then(result => {
                if (result && result.status === 200 && result.data.status === 200) {
                    this.loadNotification();
                }
            });
            this.$router.push({ name: 'order-detail', params: { orderId: notif.orderId.toString() } }).catch(() => {
                return false;
            });
        } catch {
            return false;
        }
    }
}
